import { createImmutableObjectClass } from 'immutable-less';
export default class MultiDataField extends createImmutableObjectClass({
  value: null,
  valueType: 'MULTI'
}) {
  getIsValueEmpty() {
    return this.value == null || this.value.length === 0;
  }
  getValue() {
    return this.value;
  }
  /**
   * @deprecated Prefer dot notation: .valueType
   */
  getValueType() {
    return this.valueType;
  }
}